import React, { Component } from 'react'

import * as snugNotifier from 'app/services/snugNotifier'

const genericInfoHandlerComponent = (WrappedComponent) => {
  return class InfoHandlerComponent extends Component {
    constructor(props) {
      super(props)
      this.state = {}
    }

    toastSuccess = (message = 'Success') => {
      snugNotifier.success(message)
    }

    toastError = (message = 'Failed') => {
      snugNotifier.error(message)
    }

    render() {
      return (
        <div>
          <WrappedComponent
            {...this.props}
            toastSuccess={this.toastSuccess}
            toastError={this.toastError}
          />
        </div>
      )
    }
  }
}

export default genericInfoHandlerComponent
